(function () {
  var current = document.currentScript;
  var originalSrc = current && current.src ? current.src.replace(/custom\.js(?=([?#]|$))/, 'custom-original.js') : '';

  if (originalSrc) {
    var originalScript = document.createElement('script');
    originalScript.src = originalSrc;
    originalScript.async = false;
    document.head.appendChild(originalScript);
  }

  var style = document.createElement('style');
  style.id = 'pct-mobile-review-menu-layer';
  style.textContent = '@media (max-width: 749px) { #stamped-widget-drawer { z-index: 1 !important; } #stamped-widget-drawer > .stamped-widget-button { z-index: 1 !important; } }';
  document.head.appendChild(style);
})();
